import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import invoiceGroupService from './invoice-group.service';

export interface InvoiceGroupState { }

const InvoiceGroupStore: Module<InvoiceGroupState, StoreState> = {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        async get({ commit }, { company_id }: { company_id: number }) {
            return await invoiceGroupService.get({ company_id }).then((response) => response.data);
        },
    },
};

export default InvoiceGroupStore;
